import {useContext, useEffect, useState} from "react";
import {AnimatePresence, motion} from "framer-motion";
import { dataContext } from "../../../context/context";
import './formats.css';



function Formats() {
    const { data, loading, error, isBY, isRU, isLocal } = useContext(dataContext);
    
        const mainsection = data.sectionsdata?.find(s => s.nick === 'formats');
        const mainsectionid = mainsection?.id;
        const sections = data.sectionsdata?.filter(s => s.parentid === mainsectionid);
        const firstsectionid = sections ? sections[0].id : 0;
        const [formatIndex, setFormatIndex] = useState(firstsectionid);
        const [changed, setChanged] = useState(false);

        let urlPrefix = "/images/";
        if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;

        let paragraphs = sections ? sections?.find(s => s.id === formatIndex).paragraphsdata : [];

        let image = "";
        if (paragraphs && paragraphs.length) image = paragraphs[0].image;

    useEffect(() => {
        setChanged(true)
    }, [formatIndex])

        return (
            <motion.section
                id="formats"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.25, delay: 0.5 }}
            >
                <h2>{mainsection.title}</h2>

                <div className="formatsHeader">
                    <div className="formatsHeader__inner">
                    {
                        sections.map((section, index) => (

                            <span  key={index} className={section.id === formatIndex ? "active" : ""}  onClick={() => setFormatIndex(section.id)}>{section.name}</span>

                        ))
                    }
                    </div>
                </div>


                <div className="formatsBlock">
                        <motion.div
                            initial={{ opacity: 0, rotateY: 0 }}
                            animate={{opacity: changed ? 0 : 1, rotateY: changed ? 180 : 0 }}
                            transition={{ duration: 0.2 }}
                            onAnimationComplete={() => {
                                setChanged(false);
                            }}
                            className="textBlocks">

                            {

                                paragraphs.map((paragraph, index) => (

                                    <div className="textBlock">
                                        <div className="textBlock-number">{index+1}</div>

                                        <h3>{paragraph.title}</h3>
                                        {paragraph.text}

                                    </div>

                                ))

                            }
                     </motion.div>


                    <motion.div  initial={{ opacity: 0, rotateY: 0 }}
                          animate={{opacity: changed ? 0 : 1, rotateY: changed ? 180 : 0 }}
                          transition={{ duration: 0.5 }}
                          onAnimationComplete={() => {
                              setChanged(false);
                          }}
                          className="galeryBlock">

                        {
                            (image && (<img src={urlPrefix + image} />))
                        }
                    </motion.div>

                </div>
  
            </motion.section>
        )


}

export default Formats;